import { Actions } from './industries.actions';
import { fromJS } from 'immutable';
import * as industriesTypes from './industries.types'



export const initialState = fromJS(
    {
        list: {
            isLoading: false,
            shouldReload: false,
            data: [],
            queryParams: {
                page: 1,
                page_size: 20
            },
            total: 0
        },
        createIndustry: {
            isLoading: false,
            validationErrors: {},
            data: {
                name: '',
                subIndustryList: []
            }
        },
        updateIndustry: {
            isLoading: false,
            validationErrors: {},
            data: {}
        }
    }
)


export function industriesReducer(state = initialState, action: Actions) {

    switch (action.type) {


        case industriesTypes.UPDATE_INDUSTRY_REQUEST: {
            return state
                .setIn(['updateIndustry', 'isLoading'], true)
        }

        case industriesTypes.UPDATE_INDUSTRY_SUCCESS: {
            return state
                .setIn(['updateIndustry', 'isLoading'], false)
        }


        case industriesTypes.UPDATE_INDUSTRY_FAILURE: {
            return state
                .setIn(['updateIndustry', 'isLoading'], false)
        }


        case industriesTypes.CREATE_INDUSTRY_REQUEST: {
            return state
                .setIn(['createIndustry', 'isLoading'], true)
        }

        case industriesTypes.CREATE_INDUSTRY_SUCCESS: {
            return state
                .setIn(['createIndustry', 'isLoading'], false)
        }


        case industriesTypes.CREATE_INDUSTRY_FAILURE: {
            return state
                .setIn(['createIndustry', 'isLoading'], false)
        }

        case industriesTypes.DELETE_INDUSTRY_REQUEST: {
            return state
        }

        case industriesTypes.DELETE_INDUSTRY_SUCCESS: {
            return state
                .setIn(['list', 'shouldReload'], true)
        }
        case industriesTypes.DELETE_INDUSTRY_FAILURE: {
            return state
        }

        case industriesTypes.FETCH_INDUSTRIES_REQUEST: {
            return state
                .setIn(['list', 'isLoading'], true)
                .setIn(['list', 'shouldReload'], false)
        }

        case industriesTypes.FETCH_INDUSTRIES_SUCCESS: {
            return state
                .setIn(['list', 'isLoading'], false)
                .setIn(['list', 'data'], fromJS(action.payload))
                .setIn(['list', 'total'], fromJS(action.total))
        }


        case industriesTypes.FETCH_INDUSTRIES_FAILURE: {
            return state
                .setIn(['list', 'isLoading'], false)
        }



        case industriesTypes.FETCH_INDUSTRY_REQUEST: {
            return state
                .setIn(['updateIndustry', 'isLoading'], true)
        }

        case industriesTypes.FETCH_INDUSTRY_SUCCESS: {
            return state
                .setIn(['updateIndustry', 'isLoading'], false)
                .setIn(['updateIndustry', 'data'], fromJS(action.payload))
        }


        case industriesTypes.FETCH_INDUSTRY_FAILURE: {
            return state
                .setIn(['updateIndustry', 'isLoading'], false)
        }

        case industriesTypes.UPDATE_FIELD:
            let fields = [];

            if (action.path === '') {
                fields = action.field.split('.');
            } else {
                fields = action.path
                    .split('.')
                    .concat(action.field.split('.'));
            }
            const value = action.value;

            if (fields.length === 1) {
                return state.set(fields[0], fromJS(value));
            }
            return state.setIn(fields, fromJS(value));
        case industriesTypes.SET_DEFAULT_DATA:
            const path = action.path || '';
            return state.setIn(
                path.split('.'),
                initialState.getIn(path.split('.'))
            );

        default: return state;
    }
}